import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';

const ProductListingGrid = ({ hasBigPromo , hasSmallPromo , children ,  })=>{
    const breakpoint = MediaQuery.useBreakpoint();
    const classNames = classnames('product-listing-grid', {
        'product-listing-grid--with-promos': hasBigPromo && hasSmallPromo,
        'product-listing-grid--with-big-promo': hasBigPromo && !hasSmallPromo,
        'product-listing-grid--single-promo': breakpoint === MediaQuery.BreakpointName.PHONE && (hasBigPromo && !hasSmallPromo || !hasBigPromo && hasSmallPromo),
        'product-listing-grid--col-2': breakpoint === MediaQuery.BreakpointName.PHONE,
        'product-listing-grid--col-3': breakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || breakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE,
        'product-listing-grid--col-4': breakpoint === MediaQuery.BreakpointName.DESKTOP
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, children);
};
var ProductListingGrid$1 = ProductListingGrid;

export { ProductListingGrid, ProductListingGrid$1 as default };
//# sourceMappingURL=ProductListingGrid.js.map
